import { Recording } from '@hotjar/webapp/features/Playbacks/types';

/**
 * There's a client-script bug where occasionally the window
 * dimensions get sent through as being 0. This breaks the
 * session reproduction, so we try to do an eager monkey-patch
 * here, when necessary, to assume the first valid dimensions
 * as truthful.
 */
export const patchWindowSize = (recording: Recording): Recording => {
  const width =
    recording.window_size[0] ||
    recording.page_visit_recordings.find((page) => page.window_width)?.window_width ||
    0;

  const height =
    recording.window_size[1] ||
    recording.page_visit_recordings.find((page) => page.window_height)?.window_height ||
    0;

  return { ...recording, window_size: [width, height] };
};
